import { SELECT_EMPTY_VALUE } from '@mews-commander/form';
import { useCurrentEnterpriseId } from '@mews-commander/core';
import { getReservationsAssignedCategoryIds } from '@mews-commander/legacy-entities/src/ducks/resourceCategoryAssignments';
import { useCommanderSelector } from '@mews-commander/utils';

export const useAssignedCategoryFormDefaultResourceCategoryId = (reservationIds: string[]) => {
    const enterpriseId = useCurrentEnterpriseId();
    const assignedCategoryIds = useCommanderSelector((state) =>
        getReservationsAssignedCategoryIds(state, { reservationIds, enterpriseId })
    );

    return assignedCategoryIds.length === 1 ? assignedCategoryIds[0] : SELECT_EMPTY_VALUE;
};
